import { mdiAccountMultiple, mdiBroadcast, mdiImageMultipleOutline, mdiPlayCircle } from '@mdi/js'

export const POST_TYPES = {
  IMAGE: 'image',
  LIVESTREAM_JITSI: 'livestream-jitsi',
  LIVESTREAM_OBS: 'livestream-obs',
  MEETING: 'meeting',
  VIDEO: 'video',
}

export const POST_TYPE_LIVESTREAM_ANY = 'livestream'

export const POST_TYPE_COMBOBOX = [
  {
    iconPath: mdiPlayCircle,
    label: 'Video',
    value: POST_TYPES.VIDEO,
  },
  {
    iconPath: mdiImageMultipleOutline,
    label: 'Image',
    value: POST_TYPES.IMAGE,
  },
  {
    iconPath: mdiAccountMultiple,
    label: 'Meeting',
    value: POST_TYPES.MEETING,
  },
  {
    iconPath: mdiBroadcast,
    label: 'Livestream (webcam)',
    value: POST_TYPES.LIVESTREAM_JITSI,
  },
  {
    iconPath: mdiBroadcast,
    label: 'Livestream (OBS)',
    value: POST_TYPES.LIVESTREAM_OBS,
  },
]

export const PRICING_MODELS = {
  FREE: 'free',
  HOURLY: 'pricePerHour',
  ONE_TIME: 'ticket',
}

export const POST_DURATION_COMBOBOX = [
  {
    label: '15 minutes',
    value: 15,
  },
  {
    label: '30 minutes',
    value: 30,
  },
  {
    label: '45 minutes',
    value: 45,
  },
  {
    label: '1 hour',
    value: 60,
  },
  {
    label: '1 hour 30 minutes',
    value: 90,
  },
  {
    label: '2 hours',
    value: 120,
  },
  {
    label: '6 hours',
    value: 6 * 60,
  },
  {
    label: '12 hours',
    value: 12 * 60,
  },
  {
    label: '1 day',
    value: 24 * 60,
  },
]
export const POST_DURATION_COMBOBOX_DEFAULT = POST_DURATION_COMBOBOX[3]
